// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { InternalAxiosRequestConfig } from 'axios';

import type { ClientConfigOptions } from '../types.js';
import { objectKeysToSnakeCase } from '../utils/objectKeysTo.js';

/**
 * Request interceptor: if `config.clientOptions.request.snakeCaseQueryParams`
 * is true, convert all keys of `config.params` to snake_case before axios
 * serializes the URL.
 *
 * `clientOptions` is populated by our extended `ClientOptions` from
 * `@mint-lib/api-zod-support` as a nested key on the axios config (never
 * flat-spread, to avoid colliding with axios's own keys like `response`).
 */
export function requestQueryParamsToSnakeCase(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  const snake = (config as { clientOptions?: ClientConfigOptions })
    .clientOptions?.request?.snakeCaseQueryParams;
  if (snake && config.params) {
    config.params = objectKeysToSnakeCase(
      config.params as Record<string, unknown>,
    );
  }
  return config;
}
